import React, {useEffect, useRef, useState} from 'react';
import {Button, Container, Typography} from '@mui/material';
import {useParams} from 'react-router-dom';
import {getPdfExportDownloadLink} from '../../api/services/filesService';
import {getPdfExportDownloadErrorMessage} from './pdfExportDownloadMessages';

export default function DownloadPage() {
    const {id} = useParams();
    const startedOnOpenRef = useRef(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const startDownload = async () => {
        setErrorMessage(null);
        const result = await getPdfExportDownloadLink({id});

        if (result.error) {
            setErrorMessage(getPdfExportDownloadErrorMessage(result.error.status));
            return;
        }

        window.location.assign(result.url);
    };

    useEffect(() => {
        if (!id || startedOnOpenRef.current) {
            return;
        }

        startedOnOpenRef.current = true;
        startDownload();
    }, [id]);

    return (
        <Container
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
            }}
        >
            {errorMessage
                ? (
                    <Typography variant="h5" mt={2} align="center">
                        {errorMessage}
                    </Typography>
                )
                : (
                    <>
                        <Typography variant="h5" mt={2}>
                            A download should start automatically in a few seconds...
                        </Typography>
                        <Button onClick={startDownload} mt={1}>If not, click here to download</Button>
                    </>
                )}
        </Container>
    );
}
